import React from "react";
import Button from "./Button";
import styles from "../styles/components/GeneralError.css";
import PropTypes from "prop-types";
import { notifyBugsnag } from "../utils/bugsnag";

function GeneralErrorScreen({ redirectLink, redirectText, error }) {
    if (error) {
        notifyBugsnag(error);
    }
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.text}>
                    <h1 className={styles.header}>Something's wrong.</h1>
                    <span className={styles.subtitle}>
                        We're working to resolve the issue. Please check back
                        soon.
                    </span>
                    <p className={styles.contactBlock}>
                        Please try back later, or call us at (888) 835-6828, or
                        email{" "}
                        <a href="mailto:support@wevoconversion.com">
                            support@wevoconversion.com
                        </a>
                    </p>
                </div>
                <div className={styles.buttons}>
                    <div className={styles.buttonContainer}>
                        <Button
                            color="contrast"
                            onClick={() => window.location.reload()}
                        >
                            Try again
                        </Button>
                    </div>
                    {redirectLink &&
                        redirectText && (
                            <div className={styles.buttonContainer}>
                                <Button href={redirectLink}>
                                    {redirectText}
                                </Button>
                            </div>
                        )}
                </div>
            </div>
        </div>
    );
}

GeneralErrorScreen.propTypes = {
    redirectLink: PropTypes.string,
    redirectText: PropTypes.string,
    error: PropTypes.instanceOf(Error)
};

export default GeneralErrorScreen;



// WEBPACK FOOTER //
// ./src/components/GeneralErrorScreen.js